// extracted by mini-css-extract-plugin
module.exports = {"item":"SuggestItem_item__dQAz_"};